export default {
    accesos: [
        { route: 'dashboard', modulo: '' },
        { route: '', modulo: 'DashboardIndicadores' },
        { route: '', modulo: 'DashboardVentas' },
        { route: '', modulo: 'DashboardRentabilidadNeta' },
        { route: '', modulo: 'DashboardHistorico' },
        { route: '', modulo: 'DashboardCuentas' },
        { route: '', modulo: 'DashboardCuentasRentabilidadBruta' },
        { route: '', modulo: 'DashboardCuentasConsultarPropuestas' },
        { route: '', modulo: 'DashboardAdministracion' },
        { route: '', modulo: 'DashboardProduccion' },
        { route: '', modulo: 'DashboardIndicadorVentasConsultarVentas' },
        { route: '', modulo: 'DashboardIndicadorVentasConsultarVentasExcluidas' },
        { route: '', modulo: 'DashboardIndicadorRBConsultarPresupuestos' },

        { route: 'ventas', modulo: '' },
        { route: 'ventas/presupuestosinternos', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/ABM', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/usuarios', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/produccion', modulo: '' },
        { route: 'ventas/presupuestosinternos/ordenestrabajo/:id/produccion', modulo: '' },
        { route: '', modulo: 'PresupuestosInternosDescuentoGeneral' },
        { route: '', modulo: 'PresupuestosInternosDescuentoRebate' },
        { route: '', modulo: 'PresupuestosInternosDescuentoOrdenes' },
        { route: '', modulo: 'PresupuestosInternosImagenes' },
        { route: '', modulo: 'PresupuestosInternosEditarCotizacionCertificados' },
        { route: '', modulo: 'OrdenesTrabajoEditarDescripcionCertificados' },
        { route: '', modulo: 'PresupuestosInternosAddBrief' },
        { route: '', modulo: 'PresupuestosInternosConsultarBrief' },
        { route: '', modulo: 'PresupuestosInternosFacturacionEstimada' },
        { route: '', modulo: 'PresupuestosInternosRestablecer' },
        { route: 'ventas/presupuestos-cancelados', modulo: '' },
        { route: 'ventas/subtrabajos', modulo: '' },
        { route: 'ventas/certificados-servicio', modulo: '' },
        { route: 'ventas/certificados-servicio/:id', modulo: '' },
        { route: 'ventas/certificados-servicio/presupuesto/:presupuestoId/add', modulo: '' },
        { route: 'ventas/certificados-servicio/:id/edit', modulo: '' },
        { route: 'ventas/facturas', modulo: '' },
        { route: 'ventas/facturas/:id', modulo: '' },
        { route: '', modulo: 'VentasValidarAFIP' },

        { route: 'disenio', modulo: '' },
        { route: 'disenio/dashboard', modulo: '' },
        { route: 'disenio/briefs', modulo: '' },
        { route: 'disenio/briefs/add', modulo: '' },
        { route: 'disenio/briefs/:id/edit', modulo: '' },
        { route: 'disenio/briefs/:id/adicionales', modulo: '' },
        { route: 'disenio/briefs/:id/cambios', modulo: '' },
        { route: 'disenio/briefs/:id', modulo: '' },
        { route: '', modulo: 'BriefsCancelar' },
        { route: '', modulo: 'BriefsAgregarPresupuesto' },
        // { route: '', modulo: 'BriefsSolicitudesCambios' },
        { route: '', modulo: 'BriefsEntregasValidacionInformacion' },
        { route: '', modulo: 'BriefsEntregasSolicitudCambios' },
        { route: '', modulo: 'BriefsCerrar' },
        { route: '', modulo: 'BriefsExportarListado' },

        { route: 'logistica', modulo: '' },
        { route: 'logistica/remitos', modulo: '' },
        { route: 'logistica/remitos/add', modulo: '' },
        { route: 'logistica/remitos/:id/duplicado', modulo: '' },
        { route: 'logistica/remitos/:id', modulo: '' },
        { route: '', modulo: 'RemitosActualizarEstado' },
        { route: '', modulo: 'RemitosAgregarEvaluacionTransporte' },
        { route: '', modulo: 'RemitosImagenesEdicion' },
        { route: 'logistica/destinos', modulo: '' },
        { route: 'logistica/destinos/:id', modulo: '' },
        { route: 'logistica/destinos/:id/ABM', modulo: '' },
        { route: 'logistica/actualizacion-importes', modulo: '' },

        { route: 'clientes', modulo: '' },
        { route: 'clientes/clientes', modulo: '' },
        { route: 'clientes/clientes/:id', modulo: '' },
        { route: 'clientes/clientes/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactos/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id', modulo: '' },
        { route: 'clientes/clientes/contactosadministracion/:clienteId/:id/ABM', modulo: '' },
        { route: 'clientes/cuentacorriente', modulo: '' },
        { route: 'clientes/rebate', modulo: '' },
        { route: 'clientes/rebate/ABM', modulo: '' },
        { route: '', modulo: 'ClientesConfigurarRebate' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/add', modulo: '' },
        { route: 'proveedores/proveedores/:id/edit', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },
        { route: '', modulo: 'OrdenesProveedoresAgregarEvaluacion' },
        { route: '', modulo: 'OrdenesProveedoresEnviarPDF' },
        { route: 'proveedores/cuentacorrienteproveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores/:id', modulo: '' },

        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/viaticos', modulo: '' },
        { route: 'rrhh/viaticos/add', modulo: '' },
        { route: 'rrhh/viaticos/:id', modulo: '' },
        { route: 'rrhh/viaticos/:id/edit', modulo: '' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/articulos', modulo: '' },
        { route: 'tablas/articulos/:id', modulo: '' },
        { route: 'tablas/articulos/:id/ABM', modulo: '' },
        { route: 'tablas/articulosrubros', modulo: '' },
        { route: 'tablas/articulosrubros/:id', modulo: '' },
        { route: 'tablas/articulosrubros/:id/ABM', modulo: '' },
        { route: 'tablas/articulostipos', modulo: '' },
        { route: 'tablas/articulostipos/:id', modulo: '' },
        { route: 'tablas/articulostipos/:id/ABM', modulo: '' },
        { route: 'tablas/bancos', modulo: '' },
        { route: 'tablas/bancos/:id', modulo: '' },
        { route: 'tablas/bancos/:id/ABM', modulo: '' },
        { route: 'tablas/paises', modulo: '' },
        { route: 'tablas/provincias', modulo: '' },
        { route: 'tablas/localidades', modulo: '' },
        { route: 'tablas/localidades/:id', modulo: '' },
        { route: 'tablas/localidades/:id/ABM', modulo: '' },
        { route: 'tablas/marcas', modulo: '' },
        { route: 'tablas/marcas/add', modulo: '' },
        { route: 'tablas/marcas/:id', modulo: '' },
        { route: 'tablas/marcas/:id/edit', modulo: '' },
        { route: 'tablas/rubrostrabajos', modulo: '' },
        { route: 'tablas/rubrostrabajos/:id', modulo: '' },
        { route: 'tablas/rubrostrabajos/:id/ABM', modulo: '' },
        { route: 'tablas/vendedores', modulo: '' },
        { route: 'tablas/vendedores/add', modulo: '' },
        { route: 'tablas/vendedores/:id', modulo: '' },
        { route: 'tablas/vendedores/:id/edit', modulo: '' },

        { route: 'reportes', modulo: '' },
        { route: 'reportes/ventas', modulo: '' },
        { route: 'reportes/ventas/presupuestosinternos', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-aperturas-cierres', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-premios', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-cancelados', modulo: '' },
        { route: 'reportes/ventas/presupuestos-internos-cerrados', modulo: '' },
        { route: 'reportes/ventas/ventas', modulo: '' },
        { route: 'reportes/ventas/ventas-comparativo', modulo: '' },
        { route: 'reportes/ventas/ventas-resumen-clientes', modulo: '' },
        { route: 'reportes/ventas/vendedores-comisiones', modulo: '' },
        { route: 'reportes/ventas/vendedores-comisiones-resumen', modulo: '' },
        { route: 'reportes/compras', modulo: '' },
        { route: 'reportes/compras/compras-gastos', modulo: '' },
        { route: 'reportes/compras/percepciones', modulo: '' },
        { route: 'reportes/compras/compras-fecha', modulo: '' },
        { route: 'reportes/compras/resumen-gastos', modulo: '' },
        { route: 'reportes/compras/resumen-gastos/:id', modulo: '' },
        { route: 'reportes/compras/ordenes-remitos', modulo: '' },
        { route: 'reportes/clientes', modulo: '' },
        { route: 'reportes/clientes/contactos', modulo: '' },
        { route: 'reportes/clientes/deuda', modulo: '' },
        { route: 'reportes/clientes/cobros', modulo: '' },
        { route: 'reportes/clientes/plazos', modulo: '' },
        { route: 'reportes/clientes/retenciones', modulo: '' },
        { route: 'reportes/proveedores', modulo: '' },
        { route: 'reportes/proveedores/ordenes-pendientes', modulo: '' },
        { route: 'reportes/proveedores/ordenes-rentabilidad-negativa', modulo: '' },
        { route: 'reportes/logistica', modulo: '' },
        { route: 'reportes/logistica/resumen-remitos', modulo: '' }
    ]
}
